import { Button } from '@/components/Button';

type UnauthenticatedButtonsProps = {
  onLogin: () => void;
};

export const UnauthenticatedButtons = ({
  onLogin,
}: UnauthenticatedButtonsProps) => {
  return (
    <Button onClick={onLogin} className="py-[0.8em]">
      ログイン
    </Button>
  );
};
